import { size } from '@shared/utils/breakpoints';
import styled from 'styled-components';

export const TabContainer = styled.div<{
  hoverColor: string,
  hoverFilter: string,
  primaryColor: string,
  primaryFilter: string

}>`


    display: flex;
    flex-direction: column;
    padding: 24px;
    width: 100%;
    height: 230px;
    background: #FFFFFF;

    ${`@media (max-width: ${size.medium}) {
      padding: 16px;
      height: 100px;
      flex-direction: row;
      gap: 24px;
    }`}

    border-radius: 12px;

    #tab-logo-bg {
      background: ${(props) => props.primaryColor};
    }



    &:hover {
      /* Card hover */
      box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.10);

      h5 {
        color: ${(props) => props.hoverColor};
      }

      #tab-right {
        ${(props) => props.hoverFilter}
      }

      #tab-logo-bg {
        background: ${(props) => props.hoverColor};
      }

      #tab-logo {
        ${(props) => props.primaryFilter}
      }
    }
`

export const AccountManagerName = styled.h5`
    color: #FFF;

    /* Large Screens/Headings/H5 */
    font-size: 28.13px;
    font-style: normal;
    font-weight: 400;
    line-height: 114%; /* 32.068px */
    margin-bottom: 8px;

    ${`@media (max-width: ${size.medium})`} {

        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 114%;
        /* 22.8px */

    }

  `

export const AccountManagerLabel = styled.p`
    color: #B3B3B3;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 160%; /* 22.4px */
    margin-bottom: 12px;
    `

export const AccountManagerContact = styled.a`
    display: flex;
    flex-direction: row;
    gap: 4px;
    padding:6px 0px;

    &:hover {
        text-decoration: underline;
        cursor: pointer;
        underline: #4DC6CF;
    }

    `

export const AccountMangerContactText = styled.p`
    color: #4DC6CF;
    text-align: center;
    leading-trim: both;
    text-edge: cap;

    /* Large Screens/Buttons/Button label - Small */
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 14px */
    `

export const AccountManagerTagline = styled.p`
    color:#FFFFFF;
    margin-bottom: 8px;
    /* Large Screens/Body/Small/Body - Reg */
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 144%; /* 20.16px */
    `;

export const AccountManagerContainer = styled.div`

    width: 100%;
    padding: 36px 24px;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    background: #00242E;
    color: white;

    ${`@media (max-width: ${size.medium})`} {

        padding: 16px;
    }

    ${`@media (max-width: ${size.large})`} {

        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 114%;
        /* 22.8px */

         padding: 16px 24px;

    }


    `

export const TabLogoBg = styled.div`
    display: flex;

    width: 56px;
    height: 56px;
    padding: 7px 8px 9px 8px;
    justify-content: center;
    border-radius: 999px;

   `

export const TabLogo = styled.img`


    max-width: 40px;

    max-height: 40px;


    `

export const TabLabel = styled.div`

    color: #474747;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 160%; /* 22.4px */

  `

export const TabHeader = styled.h5`

  /* Large Screens/Headings/H5 */
  font-size: 28.13px;
  font-style: normal;
  font-weight: 400;
  line-height: 114%; /* 32.068px */
  display: flex;
  flex-direction: row;
  gap: 12px;


  ${`@media (max-width: ${size.medium})`} {

    color: var(--text-heading-dark, #000);

    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 114%; /* 22.8px */
  }


  }



`
